import React, { memo, SVGProps } from 'react'

export const Info = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 20.6602C16.775 20.6602 20.6602 16.775 20.6602 12C20.6602 7.22496 16.775 3.33984 12 3.33984C7.22496 3.33984 3.33984 7.22496 3.33984 12C3.33984 16.775 7.22496 20.6602 12 20.6602ZM12 4.77984C15.9811 4.77984 19.2202 8.01888 19.2202 12C19.2202 15.9811 15.9811 19.2202 12 19.2202C8.01888 19.2202 4.77984 15.9811 4.77984 12C4.77984 8.01888 8.01888 4.77984 12 4.77984Z"
      fill="currentColor"
    />
    <path
      d="M12 16.3805C12.3974 16.3805 12.72 16.0579 12.72 15.6605V10.7914C12.72 10.3939 12.3974 10.0714 12 10.0714C11.6026 10.0714 11.28 10.3939 11.28 10.7914V15.6605C11.28 16.0579 11.6026 16.3805 12 16.3805Z"
      fill="currentColor"
    />
    <path
      d="M12 9.0624C12.192 9.0624 12.3744 8.9856 12.5088 8.8512C12.6432 8.7168 12.72 8.5248 12.72 8.3424C12.72 8.1504 12.6432 7.9584 12.5088 7.8336C12.24 7.5648 11.76 7.5648 11.4912 7.8336C11.3568 7.9584 11.28 8.1504 11.28 8.3424C11.28 8.5248 11.3568 8.7168 11.4912 8.8512C11.6256 8.9856 11.808 9.0624 12 9.0624Z"
      fill="currentColor"
    />
  </svg>
))
